<template>
  <div>
    <page-title icon="fa fa-key" main="Alterar senha"> </page-title>
    <div class="card mt-2">
      <form>
        <div class="row" style="padding: 10px 20px;">
          <div class="col-md-6">
            <div>
              <div>
                <PasswordInput
                  label="Senha atual"
                  placeholder="Senha atual"
                  v-model="password"
                />
              </div>
              <div>
                <PasswordInput
                  label="Nova senha"
                  placeholder="Nova senha"
                  v-model="newPassword"
                  v-on:input="checkPassword"
                />
                <div v-if="showPasswordEquals" class="text-danger">A nova senha deve ser diferente da senha atual.</div>
                <div v-if="showPasswordLengthError" class="text-danger">A senha deve conter pelo menos 8 caracteres.</div>
                <div v-if="showSpecialCharError" class="text-danger">A senha deve conter pelo menos um caractere especial.</div>
                <div v-if="showUppercaseError" class="text-danger">A senha deve conter pelo menos uma letra maiúscula.</div>
                <div v-if="showLowercaseError" class="text-danger">A senha deve conter pelo menos uma letra minúscula.</div>
                <div v-if="showNumberError" class="text-danger">A senha deve conter pelo menos um número.</div>
              </div>
              <div>
                <PasswordInput
                  label="Confirmar nova senha"
                  placeholder="Confirmar nova senha"
                  :max="150"
                  v-model="confirmPassword"
                  @input="checkConfirmationPassword"
                />
                <div v-if="showConfirmationPasswordError" class="text-danger">As senhas não conferem!</div>
              </div>
            </div>
            <div>
              <base-button
                @click="submitPassword"
                icon
                type="primary">
                <span class="btn-inner--text">Confirmar</span>
              </base-button>
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import FileList from "@/components/FileList";
import flatPicker from "vue-flatpickr-component";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import "flatpickr/dist/flatpickr.css";
import { required } from "vee-validate/dist/rules";
import { Select, Table, TableColumn, Dropdown, Cascader } from "element-ui";
import { extend } from "vee-validate";
import PasswordInput from "../../../components/Inputs/PasswordInput.vue";

const today = new Date();
const years = today.getFullYear();

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});
export default {
  name: "app",
  components: {
    FileList,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Multiselect,
    [Cascader.name]: Cascader,
    flatPicker,
    PageTitle,
    [Dropdown.name]: Dropdown,
    PasswordInput,
  },
  
  data() {
    return {
      password: "",
      newPassword: "",
      confirmPassword: "",
      passwordResetSuccessful: false,
      showPasswordLengthError: false,
      showSpecialCharError: false,
      showUppercaseError: false,
      showLowercaseError: false,
      showNumberError: false,
      showConfirmationPasswordError: false,
      showPasswordEquals: false
    };
  },
  methods: {
    checkPassword() {
      this.showPasswordEquals = this.newPassword === this.password;
      this.showPasswordLengthError = this.newPassword.length < 8;
      this.showSpecialCharError = !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.newPassword);
      this.showUppercaseError = !/[A-Z]/.test(this.newPassword);
      this.showLowercaseError = !/[a-z]/.test(this.newPassword);
      this.showNumberError = !/\d/.test(this.newPassword);
    },
    checkConfirmationPassword() {
      this.showConfirmationPasswordError = this.newPassword !== this.confirmPassword
    },
    submitPassword() {
      this.checkPassword()
      this.checkConfirmationPassword()

      if(!this.isPasswordValid) return;
      
      let id = this.$currentUser().id;

      this.$http.secured
      .put(`/api/v1/reset_password`, {
        user: {
          password: this.newPassword,
          password_confirmation: this.confirmPassword,
          current_password: this.password,
        }
      })
      .then(() => {
        this.$toasted.global.defaultSuccess({ msg: 'Senha Alterada com Sucesso!' });
        this.$router.push('/dashboards');
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.error[0].includes("The new password cannot be the same")) {
          this.$toasted.global.defaultError({ msg: "Senha já utilizada nos últimos 90 dias" });
        } else if (error.response && error.response.data && error.response.data.error[0].includes("A senha atual está incorreta")) {
            this.$toasted.global.defaultError({ msg: "A senha atual está incorreta" });
        }
      });
    }
  },
  computed: {
    isPasswordValid() {
      return (
        !this.showPasswordEquals &&
        !this.showPasswordLengthError &&
        !this.showSpecialCharError &&
        !this.showUppercaseError &&
        !this.showLowercaseError &&
        !this.showNumberError &&
        !this.showConfirmationPasswordError
      );
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
